import React from 'react';

import _data from '../../data';

export default class Pricing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: {}
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */

    this.setState({
      price: _data.price
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="overflow-hidden">
          <section
            id="pricing"
            className={"package-section ptb-100 " + (this.props.bgColor && this.props.bgColor === 'gray' ? 'gray-light-bg' : 'background-shape-right')} >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <div className="section-heading text-center mb-5">
                    {this.props.showTitle && this.props.showTitle === true && (
                      <span className="badge badge-primary badge-pill">
                        Nuestros Paquetes
                      </span>
                    )}
                    <h2>
                      Nuestros paquetes <br />
                      <span>planes mensuales que se ajustan a tu negocio</span>
                    </h2>
                    <p className="lead">
                      Empieza a pagar después del tercer mes en la plataforma, después puedes pausarla cuando tú quieras.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                {(this.state.price.packages || []).map((_package, index) => {
                  return (
                    <div className="col-lg-4 col-md" key={index}>
                      <div
                        className={
                          "card text-center single-pricing-pack " +
                          (_package.isFeatured ? "popular-price" : "")
                        }
                      >
                        <div className="pt-4">
                          <h5>{_package.license}</h5>
                        </div>
                        <div className="pricing-img mt-4">
                          <img
                            src="img/basic.svg"
                            alt="pricing img"
                            className="img-fluid"
                          />
                        </div>
                        <div className="card-header py-4 border-0 pricing-header">
                          <div className="h1 text-center mb-0">
                            <span className="price font-weight-bolder">
                              {_package.price}
                            </span>
                          </div>
                        </div>
                        <div className="card-body">
                          <ul className="list-unstyled text-sm mb-4 pricing-feature-list">
                            {(_package.features || []).map(feature => {
                              return <li key={feature}>{feature}</li>;
                            })}
                          </ul>
                          <a
                            href="/#"
                            className={
                              "btn mb-3 " +
                              (_package.isFeatured
                                ? "solid-btn"
                                : "outline-btn")
                            }
                            target="_blank"
                          >
                            Contáctanos
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="mt-5 text-center">
                <p className="mb-2">
                  Necesitas asistencia personalizada?{" "}
                  <a href="/#" className="color-secondary">
                    Contáctanos
                  </a>
                </p>
              </div>
              {!(this.props.hideFaq && this.props.hideFaq === true) && this.props.theme !== "four" && (
                <div className="row mt-5">
                  <div className="col-lg-6">
                    <div id="accordion-1" className="accordion accordion-faq">
                      <div className="card">
                        <div
                          className="card-header py-4"
                          id="heading-1-1"
                          data-toggle="collapse"
                          role="button"
                          data-target="#collapse-1-1"
                          aria-expanded="false"
                          aria-controls="collapse-1-1"
                        >
                          <h6 className="mb-0">
                            <span className="ti-receipt mr-3"></span> ¿Cuáles son los requisitos de registro? 
                          </h6>
                        </div>
                        <div
                          id="collapse-1-1"
                          className="collapse"
                          aria-labelledby="heading-1-1"
                          data-parent="#accordion-1"
                        >
                          <div className="card-body">
                            <p>
                              Nuestro proceso de registro es muy sencillo y en menos de 10 minutos puedes completarlo. 
                              Asegúrate de tener tu RUC, Datos de Representante Legal, y Datos Bancarios a la mano para poder crear tu cuenta y aprobar tu negocio.
                              Puedes registrarte en <a href="https://registro.frisbee.com.ec" target="_blank" rel="noopener noreferrer">https://registro.frisbee.com.ec</a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div
                          className="card-header py-4"
                          id="heading-1-2"
                          data-toggle="collapse"
                          role="button"
                          data-target="#collapse-1-2"
                          aria-expanded="false"
                          aria-controls="collapse-1-2"
                        >
                          <h6 className="mb-0">
                            <span className="ti-gallery mr-3"></span>
                            ¿ Como cargo mi inventario a la plataforma de Frisbee?
                          </h6>
                        </div>
                        <div
                          id="collapse-1-2"
                          className="collapse"
                          aria-labelledby="heading-1-2"
                          data-parent="#accordion-1"
                        >
                          <div className="card-body">
                            <p>
                              Cuando tu empresa sea aprobada por nuestro Equipo Legal en menos de 24 horas, vamos a darte las credenciales para que ingreses a Frisbee Business Portal.
                              El portal donde podrás manejar tu negocio, elegir tu plan y cargar información básica de tu marca. Después puedes crear tus productos de varias formas.
                              Puedes crearlos uno por uno en la plataforma web, también puedes descargar la Plantilla Excel de carga para poder subir todos tus productos. Contáctanos si tienes alguna duda.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div
                          className="card-header py-4"
                          id="heading-1-3"
                          data-toggle="collapse"
                          role="button"
                          data-target="#collapse-1-3"
                          aria-expanded="false"
                          aria-controls="collapse-1-3"
                        >
                          <h6 className="mb-0">
                            <span className="ti-wallet mr-3"></span> ¿Qué es Frisbee Business Portal?
                          </h6>
                        </div>
                        <div
                          id="collapse-1-3"
                          className="collapse"
                          aria-labelledby="heading-1-3"
                          data-parent="#accordion-1"
                        >
                          <div className="card-body">
                            <p>
                              En Frisbee Business Portal puedes manejar todo tu negocio en Frisbee facilmente, desde cualquier explorador web. 
                              Puedes crear, eliminar y editar productos. También ver datos de los clientes que te han comprado, crear descuentos, participar en Flash Sales, ver en un mapa el estado de todos tus pedidos y manejar garantías y devoluciones facilmente.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div id="accordion-2" className="accordion accordion-faq">
                      <div className="card">
                        <div
                          className="card-header py-4"
                          id="heading-2-1"
                          data-toggle="collapse"
                          role="button"
                          data-target="#collapse-2-1"
                          aria-expanded="false"
                          aria-controls="collapse-2-1"
                        >
                          <h6 className="mb-0">
                            <span className="ti-receipt mr-3"></span>
                            ¿Cómo se manejan los cambios, devoluciones y garantías?
                          </h6>
                        </div>
                        <div
                          id="collapse-2-1"
                          className="collapse"
                          aria-labelledby="heading-2-1"
                          data-parent="#accordion-2"
                        >
                          <div className="card-body">
                            <p>
                              Cuando te registras, aceptas nuestros Términos y Condiciones asi como nuestra Política de Garantías y Devoluciones.
                              Para resumirlo, el cliente final tiene 72 horas para devolver el producto totalmente gratis, nosotros cubrimos el despacho y nos aseguramos de recibir el producto exactamente como lo entregamos.
                              Después, tú como empresa debes responder por fallas de calidad, y garantías a los clientes. Nuestra plataforma lo hace muy fácil revisar la garantía, ver las fotos del producto y tomar la resolución final.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div
                          className="card-header py-4"
                          id="heading-2-2"
                          data-toggle="collapse"
                          role="button"
                          data-target="#collapse-2-2"
                          aria-expanded="false"
                          aria-controls="collapse-2-2"
                        >
                          <h6 className="mb-0">
                            <span className="ti-lock mr-3"></span> 
                            ¿Cómo recaudo el dinero generado por mis ventas?
                          </h6>
                        </div>
                        <div
                          id="collapse-2-2"
                          className="collapse"
                          aria-labelledby="heading-2-2"
                          data-parent="#accordion-2"
                        >
                          <div className="card-body">
                            <p>
                              Tan pronto recibas nuestra notificación de pedido pagado, tu nos emites una factura y nosotros emitimos una factura por la comisión por la venta.
                              Después de 72 horas de la emisión de las facturas, nosotros te depositamos tus ventas en tu cuenta bancaria.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div
                          className="card-header py-4"
                          id="heading-2-3"
                          data-toggle="collapse"
                          role="button"
                          data-target="#collapse-2-3"
                          aria-expanded="false"
                          aria-controls="collapse-2-3"
                        >
                          <h6 className="mb-0">
                            <span className="ti-widget mr-3"></span>
                            ¿Cómo puedo fidelizar a mis clientes?
                          </h6>
                        </div>
                        <div
                          id="collapse-2-3"
                          className="collapse"
                          aria-labelledby="heading-2-3"
                          data-parent="#accordion-2"
                        >
                          <div className="card-body">
                            <p>
                              Frisbee tiene muchas herramientas para que puedas fidelizar a tus clientes y motives a tus clientes a hacer recompras. 
                              Puedes crear descuentos personalizados para clientes específicos y envíarselos directamente a ellos. También puedes crear promociones especiales con Puntos Frisbee.
                              Es decir el cliente puede redimir 2 veces la cantidad de Puntos Frisbee cuando hace una recompra en la misma marca.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!(this.props.hideFaq && this.props.hideFaq === true) && this.props.theme === "four" && (
                <div className="row pt-5">
                  <div className="col-md-6">
                    <div className="single-faq">
                      <h5>How can I pay for this?</h5>
                      <p>
                        Intrinsicly implement high standards in strategic theme
                        areas via inexpensive solutions. Assertively
                        conceptualize prospective bandwidth whereas client-based
                        imperatives.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-faq">
                      <h5>Is it possible to pay yearly?</h5>
                      <p>
                        Assertively iterate user friendly innovation without
                        open-source markets. Monotonectally extend resource
                        sucking manufactured products without high-payoff
                        paradigms. Objectively customize ubiquitous information
                        before economically sound relationships.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-faq">
                      <h5>Do you offer discounts on multiple items?</h5>
                      <p>
                        Dramatically target focused testing procedures after
                        holistic ideas. Collaboratively maximize high-payoff ROI
                        and value-added products. Distinctively deliver
                        cooperative collaboration and idea-sharing whereas
                        customized
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-faq">
                      <h5>Is VAT included in plan prices?</h5>
                      <p>
                        Distinctively simplify high-quality initiatives for
                        highly efficient applications. Monotonectally repurpose
                        integrated customer service after magnetic e-services.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-faq">
                      <h5>Will I pay more for some features?</h5>
                      <p>
                        Enthusiastically pontificate resource-leveling supply
                        chains whereas scalable markets. Authoritatively
                        streamline resource maximizing methods of empowerment
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-faq">
                      <h5>
                        Why are there no limits on the number of messages?
                      </h5>
                      <p>
                        Assertively target turnkey ideas for market-driven
                        portals. Appropriately e-enable world-class intellectual
                        capital whereas 2.0 mindshare.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}
